import { Container, Row } from "reactstrap";
import { Dashboard, ECommerceDashboard } from "../../../../constants";
import CustomerGrowth from "./CustomerGrowth";
import LatestOfferProduct from "./latestOfferProduct";
import RecentOrders from "./recentOrders";
import SalesDetails from "./SalesDetails";
import SellingProduct from "./SellingProduct";
import Summary from "./Summary";
import TopTransaction from "./TopTransaction";
import TotalSale from "./TotalSale";
import WeeklyUserActivity from "./WeeklyUserActivity";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

const ECommerceContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ECommerceDashboard} parent={Dashboard} />
      <Container fluid className="ecommerce-dashboard">
        <Row>
          <TotalSale />
          <Summary />
          <RecentOrders />
          <CustomerGrowth colClass="proorder-xl-4 box-col-6 col-lg-6 col-xl-5" />
          <TopTransaction />
          <WeeklyUserActivity colClass="col-md-6 box-col-6" />
          <SellingProduct />
          <SalesDetails />
          <LatestOfferProduct colClass="proorder-xl-8 col-xl-6" />
        </Row>
      </Container>
    </>
  );
};

export default ECommerceContainer;
